import { Clock, Mail, Bell } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card, CardContent } from '../components/ui/card';

export function ComingSoon() {
  return (
    <div className='tailwind-prefix page-content'>
 <div className="h-full flex-1 flex-col bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        <Card className="border-none shadow-2xl">
          <CardContent className="p-8 md:p-12">
            {/* Icon */}
            <div className="flex justify-center mb-8">
              <div className="relative">
                <div className="absolute inset-0 bg-blue-500 rounded-full blur-2xl opacity-20 animate-pulse"></div>
                <div className="relative p-6 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full">
                  <Clock className="size-12 text-white" />
                </div>
              </div>
            </div>

            {/* Heading */}
            <div className="text-center mb-8">
              <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Coming Soon
              </h1>
              <p className="text-lg text-slate-600 mb-2">
                We're working on something amazing!
              </p>
             
            </div>

       
          </CardContent>
        </Card>
      </div>
    </div>
    </div>
   
  );
}
